<template>
  <div class="banner">
    <div class="wrap">
      <div class="text">
        <h3>Политика в отношении обработки персональных данных</h3>
      </div>
    </div>
  </div>

  <div class="text-content">
    <p>ПОЛИТИКА</p>

    <p>в отношении обработки персональных данных</p>

    <p>Индивидуального предпринимателя Ворониной О.Д.</p>

    <p>(Дом для гостей &laquo;Каменный цветок&raquo;)</p>

    <p>Редакция от &laquo;10&raquo; сентября 2026 г.</p>

    <p>1. Общие положения</p>

    <p>1.1. Настоящая Политика определяет порядок обработки персональных данных (далее &mdash; ПДн) и меры по обеспечению их безопасности у Индивидуального предпринимателя Ворониной Оксаны Дмитриевны (далее &mdash; Оператор), владеющей Домом для гостей &laquo;Каменный цветок&raquo; (далее &mdash; Объект).</p>

    <p>1.2. Политика разработана в соответствии с:</p>

    <ul>
      <li>Конституцией Российской Федерации;</li>
      <li>Трудовым кодексом Российской Федерации;</li>
      <li>Гражданским кодексом Российской Федерации (гл. 35, ст. 671&ndash;688);</li>
      <li>Налоговым кодексом Российской Федерации;</li>
      <li>Федеральным законом от 27.07.2006 № 152-ФЗ &laquo;О персональных данных&raquo; (далее &mdash; Федеральный закон № 152-ФЗ);</li>
      <li>Федеральным законом от 27.07.2006 № 149-ФЗ &laquo;Об информации, информационных технологиях и о защите информации&raquo;;</li>
      <li>Постановлением Правительства РФ от 15.09.2008 № 687;</li>
      <li>Постановлением Правительства РФ от 01.11.2012 № 1119;</li>
      <li>Приказом ФСТЭК России от 18.02.2013 № 21.</li>
    </ul>

    <p>1.3. Использование Сайта <a href="https://kamcvet-house.ru/" target="_blank">https://kamcvet-house.ru/</a> и Модуля онлайн-бронирования RealtyCalendar означает согласие Пользователя с условиями настоящей Политики. При несогласии с условиями Политики Пользователь обязан прекратить использование Сайта и Модуля.</p>

    <p>1.4. Настоящая Политика является общедоступным документом и размещается на Сайте Оператора по адресу: <a href="https://kamcvet-house.ru/" target="_blank">https://kamcvet-house.ru/</a>.</p>

    <p>1.5. В связи с осуществлением автоматизированной обработки персональных данных через Модуль RealtyCalendar, а также при передаче данных в банк, налоговые органы (ФНС) и Социальный фонд России (СФР) через электронные сервисы, Оператор подал уведомление в уполномоченный орган по защите прав субъектов персональных данных (Роскомнадзор) в соответствии со статьёй 22 Федерального закона № 152-ФЗ до начала обработки.</p>

    <p>1.6. Более подробный перечень целей, категорий субъектов, перечней ПДн и сроков хранения содержится в Положении об обработке и защите персональных данных, утверждённом Оператором.</p>

    <p>&nbsp;</p>

    <p>&nbsp;</p>

    <p>2. Основные понятия</p>

    <p>2.1. Персональные данные &mdash; любая информация, относящаяся к прямо или косвенно определённому или определяемому физическому лицу (гостю, сотруднику, контрагенту) (статья 3 Федерального закона № 152-ФЗ).</p>

    <p>2.2. Оператор &mdash; Индивидуальный предприниматель Воронина Оксана Дмитриевна, самостоятельно организующая и осуществляющая обработку персональных данных, а также определяющая цели обработки, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными (статья 3 Федерального закона № 152-ФЗ).</p>

    <p>2.3. Обработка персональных данных &mdash; любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), блокирование, удаление, уничтожение персональных данных (статья 3 Федерального закона № 152-ФЗ).</p>

    <p>2.4. Субъект персональных данных &mdash; физическое лицо, к которому относятся персональные данные (Гость, сотрудник, контрагент, выгодоприобретатель).</p>

    <p>2.5. Лицо, осуществляющее обработку по поручению Оператора &mdash; ООО &laquo;Апартмент системс&raquo;, которому Оператор поручает обработку персональных данных на основании договора в соответствии с частью 3 статьи 6 Федерального закона № 152-ФЗ.</p>

    <p>3. Цели обработки персональных данных</p>

    <p>Оператор обрабатывает персональные данные исключительно для законных целей:</p>

    <table>
      <thead>
      <tr>
        <td>
          <p>№</p>
        </td>
        <td>
          <p>Цель обработки</p>
        </td>
        <td>
          <p>Правовое основание</p>
        </td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <p>1</p>
        </td>
        <td>
          <p>Бронирование, заселение и исполнение договоров с гостями Дома для гостей &laquo;Каменный цветок&raquo; (в том числе через модуль онлайн-бронирования RealtyCalendar на Сайте), с контрагентами, а также договоров, по которым субъект персональных данных является выгодоприобретателем или поручителем</p>
        </td>
        <td>
          <p>п. 5 ч. 1 ст. 6 Федерального закона № 152-ФЗ (исполнение договора); п. 2 ч. 1 ст. 6 (для паспортных данных граждан РФ &mdash; регистрация по месту пребывания); п. 1 ч. 1 ст. 6 (для поручения обработки ООО &laquo;Апартмент системс&raquo;)</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>2</p>
        </td>
        <td>
          <p>Ведение кадрового и бухгалтерского учёта (в отношении сотрудников, в том числе уволенных), включая перечисление заработной платы</p>
        </td>
        <td>
          <p>п. 2 ч. 1 ст. 6 Федерального закона № 152-ФЗ (исполнение обязанностей по закону); п. 5 ч. 1 ст. 6 (исполнение трудового договора)</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>3</p>
        </td>
        <td>
          <p>Обеспечение соблюдения трудового законодательства (включая воинский учёт) в отношении сотрудников (в том числе уволенных)</p>
        </td>
        <td>
          <p>п. 2 ч. 1 ст. 6 Федерального закона № 152-ФЗ</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>4</p>
        </td>
        <td>
          <p>Обеспечение соблюдения налогового и пенсионного законодательства (сдача отчётности в ФНС и СФР) в отношении сотрудников (в том числе уволенных) и контрагентов &mdash; физических лиц</p>
        </td>
        <td>
          <p>п. 2 ч. 1 ст. 6 Федерального закона № 152-ФЗ</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>5</p>
        </td>
        <td>
          <p>Информирование клиентов о статусе бронирования, условиях заселения и проживания (в рамках исполнения договора)</p>
        </td>
        <td>
          <p>п. 5 ч. 1 ст. 6 Федерального закона № 152-ФЗ (исполнение договора)</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>6</p>
        </td>
        <td>
          <p>Сбор статистических данных и анализ поведения посетителей Сайта с использованием сервиса веб-аналитики Яндекс.Метрика для улучшения работы Сайта и качества обслуживания</p>
        </td>
        <td>
          <p>п. 1 ч. 1 ст. 6 Федерального закона № 152-ФЗ (согласие субъекта)</p>
        </td>
      </tr>
      </tbody>
    </table>

    <p>4. Объём и категории обрабатываемых персональных данных</p>

    <p>Оператор собирает только те данные, которые необходимы для конкретной цели (принцип минимальной достаточности, статья 5 Федерального закона № 152-ФЗ).</p>

    <p>4.1. Для гостей и третьих лиц (выгодоприобретателей)</p>

    <ul>
      <li>Фамилия, имя, отчество (при наличии);</li>
      <li>Номер телефона;</li>
      <li>Адрес электронной почты;</li>
      <li>Гражданство;</li>
      <li>Дата рождения (число/месяц/год);</li>
      <li>Пол;</li>
      <li>Адрес регистрации;</li>
      <li>Данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, страна рождения, регион рождения, район, город, населённый пункт);</li>
      <li>Информация о гостях (при бронировании для третьих лиц).</li>
    </ul>

    <p>Важно: Через форму на Сайте запрашиваются контактные данные. Полные паспортные данные фиксируются администратором лично при заселении гостя для оформления бумажного договора.</p>

    <p>4.2. Для сотрудников (в том числе уволенных)</p>

    <ul>
      <li>Фамилия, имя, отчество;</li>
      <li>Дата и место рождения;</li>
      <li>Паспортные данные;</li>
      <li>ИНН, СНИЛС;</li>
      <li>Сведения об образовании и квалификации;</li>
      <li>Сведения о трудовой деятельности (стаж, предыдущие места работы);</li>
      <li>Сведения о воинском учёте (для военнообязанных);</li>
      <li>Семейное положение (только для предоставления вычетов, пособий, алиментов &mdash; при наличии заявления);</li>
      <li>Гражданство;</li>
      <li>Реквизиты банковского счёта (для перечисления зарплаты).</li>
    </ul>

    <p>4.3. Для контрагентов (представителей юридических лиц и физических лиц)</p>

    <ul>
      <li>Фамилия, имя, отчество (при наличии);</li>
      <li>Реквизиты организации или ИП;</li>
      <li>Банковские счета (маскированные данные, полные реквизиты не хранятся);</li>
      <li>Контактные данные (телефон, адрес электронной почты);</li>
      <li>ИНН (только для ИП и самозанятых; для физических лиц, не являющихся предпринимателями, ИНН не требуется).</li>
    </ul>

    <p>4.4. Технические данные при посещении Сайта</p>

    <p>При использовании Сайта автоматически собираются следующие данные:</p>

    <ul>
      <li>IP-адрес;</li>
      <li>данные файлов cookie (идентификаторы сессии, уникальные идентификаторы);</li>
      <li>сведения о браузере и устройстве (тип, версия, операционная система);</li>
      <li>дата и время посещения;</li>
      <li>сведения о действиях на Сайте, просмотренных страницах, источнике перехода.</li>
    </ul>

    <p>Указанные данные собираются с использованием сервиса веб-аналитики Яндекс.Метрика для анализа посещаемости и улучшения работы Сайта.</p>

    <p>5. Правовые основания обработки</p>

    <p>Оператор обрабатывает персональные данные на следующих правовых основаниях (статья 6 Федерального закона № 152-ФЗ):</p>

    <ol>
      <li>Для исполнения договора с субъектом (бронирование, заселение, оказание услуг) &mdash; п. 5 ч. 1 ст. 6.</li>
      <li>Для выполнения обязанностей, возложенных законом (миграционный учёт, налоговый учёт, кадровое делопроизводство, воинский учёт, архивное хранение) &mdash; п. 2 ч. 1 ст. 6.</li>
      <li>С согласия субъекта &mdash; для поручения обработки персональных данных ООО &laquo;Апартмент системс&raquo; (ч. 3 ст. 6 152-ФЗ) и для сбора аналитических данных через Яндекс.Метрику &mdash; п. 1 ч. 1 ст. 6.</li>
    </ol>

    <p>6. Порядок и условия обработки</p>

    <p>6.1. Способы обработки</p>

    <p>Оператор осуществляет обработку персональных данных двумя способами:</p>

    <table>
      <thead>
      <tr>
        <td>
          <p>Способ</p>
        </td>
        <td>
          <p>Описание</p>
        </td>
        <td>
          <p>Когда применяется</p>
        </td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <p>Автоматизированный</p>
        </td>
        <td>
          <p>Через модуль онлайн-бронирования RealtyCalendar на Сайте; через личные кабинеты банка, ФНС, СФР; через сервис веб-аналитики Яндекс.Метрика</p>
        </td>
        <td>
          <p>При онлайн-бронировании, перечислении зарплаты, сдаче отчётности, сборе статистики</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Неавтоматизированный</p>
        </td>
        <td>
          <p>На бумажных носителях (анкеты гостей, договоры, кадровые документы)</p>
        </td>
        <td>
          <p>При личном обращении гостей, оформлении договора, кадровом учёте, хранении документов</p>
        </td>
      </tr>
      </tbody>
    </table>

    <p>6.2. Поручение обработки персональных данных</p>

    <p>Для работы модуля онлайн-бронирования Оператор поручает обработку персональных данных гостей компании-разработчику &mdash; ООО &laquo;Апартмент системс&raquo; (далее &mdash; Обработчик).</p>

    <p>Реквизиты Обработчика:</p>

    <ul>
      <li>ИНН: 7729748911</li>
      <li>ОГРН: 1137746760381</li>
      <li>Юридический адрес: 119607, г. Москва, ул. Раменки, д. 25, корп. 3, кв. 668</li>
      <li>Сайт: <a href="https://new.realtycalendar.ru/" target="_blank">https://new.realtycalendar.ru/</a></li>
      <li>E-mail: support@realtycalendar.ru</li>
    </ul>

    <p>В соответствии с частью 3 статьи 6 Федерального закона № 152-ФЗ поручение обработки персональных данных ООО &laquo;Апартмент системс&raquo; осуществляется с согласия субъекта персональных данных. Согласие оформляется отдельным документом (отдельная форма на Сайте) и содержит указание на Обработчика, перечень передаваемых данных и цели обработки.</p>

    <p>Обработчик осуществляет обработку персональных данных в объёме, необходимом для функционирования Модуля, и принимает меры по защите персональных данных в соответствии с требованиями Федерального закона № 152-ФЗ.</p>

    <p>Серверы Обработчика расположены на территории Российской Федерации:</p>

    <ul>
      <li>г. Мытищи, ул. Силикатная, д. 19;</li>
      <li>г. Владимир, ул. Энергетиков, д. 37, корп. 2;</li>
      <li>г. Сасово, ул. Пушкина, д. 21;</li>
      <li>г. Калуга, 1-й Автомобильный проезд, д. 8.</li>
    </ul>

    <p>Зарубежные серверы для обработки персональных данных граждан Российской Федерации не используются, что соответствует требованиям части 5 статьи 18 Федерального закона № 152-ФЗ.</p>

    <p>6.3. Передача данных иным третьим лицам</p>

    <p>Помимо Обработчика, персональные данные могут передаваться:</p>

    <ul>
      <li>в банк &mdash; для перечисления заработной платы сотрудникам (на основании договора банковского счёта и поручения Оператора);</li>
      <li>в налоговые органы (ФНС) и Социальный фонд России (СФР) &mdash; для исполнения обязанностей по представлению отчётности в соответствии с законодательством;</li>
      <li>в сервис веб-аналитики Яндекс.Метрика &mdash; для сбора статистических данных о посещении Сайта (на основании согласия субъекта, полученного через cookie-баннер).</li>
    </ul>

    <p>&nbsp;</p>

    <p>6.4. Хранение персональных данных</p>

    <p>Персональные данные хранятся в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели их обработки, если срок хранения не установлен федеральным законом или договором (статья 5 Федерального закона № 152-ФЗ).</p>

    <table>
      <thead>
      <tr>
        <td>
          <p>Категория данных</p>
        </td>
        <td>
          <p>Срок хранения</p>
        </td>
        <td>
          <p>Правовое основание</p>
        </td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <p>Данные гостей</p>
        </td>
        <td>
          <p>В течение срока действия договора и 5 лет после его прекращения</p>
        </td>
        <td>
          <p>ст. 196 ГК РФ (срок исковой давности)</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Данные сотрудников (личные дела, трудовые книжки)</p>
        </td>
        <td>
          <p>50 лет после увольнения</p>
        </td>
        <td>
          <p>ст. 22.1 Федерального закона от 22.10.2004 № 125-ФЗ &laquo;Об архивном деле в Российской Федерации&raquo;</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Документы воинского учёта (карточки формы № 10)</p>
        </td>
        <td>
          <p>5 лет после увольнения</p>
        </td>
        <td>
          <p>Приказ Росархива от 20.12.2019 № 236</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Бухгалтерские документы</p>
        </td>
        <td>
          <p>Не менее 5 лет</p>
        </td>
        <td>
          <p>п. 8 ч. 1 ст. 23 НК РФ</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Документы по налогам</p>
        </td>
        <td>
          <p>4 года</p>
        </td>
        <td>
          <p>подп. 5 п. 3 ст. 24 НК РФ</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Данные Яндекс.Метрики (cookie, IP-адрес, поведенческие данные)</p>
        </td>
        <td>
          <p>До отзыва согласия субъектом, но не более 2 лет с момента последнего визита Пользователя</p>
        </td>
        <td>
          <p>п. 1 ч. 1 ст. 6 Федерального закона № 152-ФЗ (согласие субъекта)</p>
        </td>
      </tr>
      </tbody>
    </table>

    <p>По достижении целей обработки или в случае утраты необходимости в их достижении персональные данные подлежат уничтожению.</p>

    <p>7. Использование файлов cookie и аналитических данных</p>

    <p>7.1. Общие сведения о файлах cookie</p>

    <p>При посещении Сайта <a href="https://kamcvet-house.ru/" target="_blank">https://kamcvet-house.ru/</a> на устройстве Пользователя сохраняются небольшие текстовые файлы &mdash; файлы cookie. Они позволяют Сайту запоминать информацию о действиях и предпочтениях Пользователя.</p>

    <p>7.2. Категории используемых файлов cookie</p>

    <p>Оператор использует следующие категории файлов cookie:</p>

    <table>
      <thead>
      <tr>
        <td>
          <p>Категория</p>
        </td>
        <td>
          <p>Назначение</p>
        </td>
        <td>
          <p>Требуется ли согласие</p>
        </td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <p>Строго необходимые (технические)</p>
        </td>
        <td>
          <p>Обеспечивают базовую функциональность Сайта: навигацию, сохранение сессии, корректную передачу данных между страницами и работу форм. Без них Сайт не может работать корректно.</p>
        </td>
        <td>
          <p>Не требуют согласия (обрабатываются на основании п. 5 ч. 1 ст. 6 152-ФЗ)</p>
        </td>
      </tr>
      <tr>
        <td>
          <p>Аналитические (Яндекс.Метрика)</p>
        </td>
        <td>
          <p>Собирают данные о поведении посетителей: IP-адрес, уникальные идентификаторы, просмотренные страницы, время на сайте, источник перехода. Используются для анализа посещаемости и улучшения работы Сайта.</p>
        </td>
        <td>
          <p>Требуется явное согласие Пользователя</p>
        </td>
      </tr>
      </tbody>
    </table>

    <p>7.3. Аналитические файлы cookie (Яндекс.Метрика)</p>

    <p>На Сайте используется сервис веб-аналитики Яндекс.Метрика, который собирает следующие данные:</p>

    <ul>
      <li>IP-адрес;</li>
      <li>уникальные идентификаторы cookie (_ym_uid, _ym_d);</li>
      <li>данные о браузере и устройстве;</li>
      <li>сведения о просмотренных страницах, времени посещения, источнике перехода.</li>
    </ul>

    <p>Правовое основание: Обработка указанных данных осуществляется на основании пункта 1 части 1 статьи 6 Федерального закона № 152-ФЗ (согласие субъекта персональных данных).</p>

    <p>Согласие: Для сбора аналитических данных через Яндекс.Метрику Оператор получает явное согласие Пользователя через cookie-баннер при первом посещении Сайта. Скрипт Яндекс.Метрики загружается только после нажатия Пользователем кнопки &laquo;Разрешить&raquo;. При отказе от аналитических cookie скрипт не загружается, данные не собираются.</p>

    <p>7.4. Управление файлами cookie</p>

    <p>Пользователь может в любой момент изменить настройки использования файлов cookie в своём браузере или отозвать своё согласие через настройки cookie на Сайте. Отключение строго необходимых cookie может привести к недоступности отдельных функций Сайта (например, оформление бронирования).</p>

    <p>7.5. Передача данных из файлов cookie третьим лицам</p>

    <p>Данные, собранные с помощью аналитических cookie, передаются в сервис веб-аналитики Яндекс.Метрика (ООО &laquo;Яндекс&raquo;). Обработка этих данных осуществляется ООО &laquo;Яндекс&raquo; в соответствии с его политикой конфиденциальности. Передача данных государственным органам осуществляется исключительно по требованию законодательства Российской Федерации.</p>

    <p>8. Актуализация, исправление, удаление и уничтожение данных</p>

    <p>8.1. Субъект персональных данных имеет право требовать уточнения своих персональных данных, их блокирования или уничтожения, если они являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки (статья 14 Федерального закона № 152-ФЗ).</p>

    <p>8.2. Для реализации своих прав субъект персональных данных может обратиться к Оператору лично или направить письменный запрос на адрес электронной почты kamcvet-house@mail.ru с темой &laquo;Запрос по ПДн&raquo; или по почтовому адресу: Республика Башкортостан, Белорецкий район, с. Новоабзаково, ул. Луговая, д. 5.</p>

    <p>8.3. Запрос должен содержать:</p>

    <ul>
      <li>фамилию, имя, отчество субъекта персональных данных;</li>
      <li>номер основного документа, удостоверяющего личность субъекта или его представителя, сведения о дате выдачи указанного документа и выдавшем его органе;</li>
      <li>сведения, подтверждающие участие субъекта в отношениях с Оператором (номер бронирования, дата заезда или иные сведения);</li>
      <li>подпись субъекта персональных данных или его представителя.</li>
    </ul>

    <p>8.4. Срок рассмотрения запроса &mdash; 10 рабочих дней с момента его получения (ч. 3 ст. 14 Федерального закона № 152-ФЗ). Указанный срок может быть продлён, но не более чем на 5 рабочих дней, с направлением субъекту мотивированного уведомления о причинах продления срока.</p>

    <p>8.5. Субъект персональных данных имеет право отозвать своё согласие на обработку персональных данных в любое время (ч. 2 ст. 9 Федерального закона № 152-ФЗ). Для отзыва согласия необходимо направить письменное уведомление на адрес электронной почты kamcvet-house@mail.ru или по почтовому адресу Оператора.</p>

    <p>8.6. В случае отзыва согласия Оператор обязан прекратить обработку и уничтожить персональные данные в срок, не превышающий 30 дней, если иное не предусмотрено федеральным законом или если Оператор не вправе продолжать обработку без согласия на основаниях, предусмотренных пунктами 2&ndash;11 части 1 статьи 6 Федерального закона № 152-ФЗ (ч. 5 ст. 21 Федерального закона № 152-ФЗ).</p>

    <p>8.7. Уничтожение персональных данных на бумажных носителях осуществляется с использованием шредера или путём сжигания. Уничтожение подтверждается актом об уничтожении персональных данных.</p>

    <p>9. Меры защиты персональных данных</p>

    <p>Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения, а также от иных неправомерных действий (статья 19 Федерального закона № 152-ФЗ):</p>

    <ol>
      <li>Назначено лицо, ответственное за организацию обработки персональных данных (Индивидуальный предприниматель).</li>
      <li>Утверждены локальные акты по обработке и защите персональных данных (Положение № 2, настоящая Политика).</li>
      <li>Сотрудники (при их наличии) ознакомлены с правилами обработки персональных данных под роспись.</li>
      <li>Установлен антивирус на рабочие компьютеры (сертифицированное ПО).</li>
      <li>Доступ к личному кабинету RealtyCalendar осуществляется через парольную защиту.</li>
      <li>Бумажные носители защищены от несанкционированного доступа (хранение в запираемом шкафу).</li>
      <li>Используется защищённый протокол HTTPS на Сайте.</li>
      <li>Осуществляется внутренний контроль за соблюдением требований законодательства о персональных данных.</li>
      <li>Обеспечена локализация баз данных с персональными данными граждан РФ на территории Российской Федерации.</li>
    </ol>

    <p>10. Контактная информация Оператора</p>

    <p>Если у вас возникли вопросы по поводу обработки ваших персональных данных, пожалуйста, обращайтесь:</p>

    <p>Оператор:</p>

    <p>Индивидуальный предприниматель Воронина Оксана Дмитриевна</p>

    <p>ИНН: 744400084688</p>

    <p>ОГРНИП: 304744422200392</p>

    <p>Адрес объекта: Республика Башкортостан, Белорецкий район, с. Новоабзаково, ул. Луговая, д. 5</p>

    <p>Контактные телефоны администратора: 8-951-237-9748, 8-909-092-0182</p>

    <p>E-mail: kamcvet-house@mail.ru</p>

    <p>Сайт: <a href="https://kamcvet-house.ru/" target="_blank">https://kamcvet-house.ru/</a></p>

    <p>Лицо, осуществляющее обработку по поручению Оператора:</p>

    <p>ООО &laquo;Апартмент системс&raquo;</p>

    <p>ИНН: 7729748911</p>

    <p>ОГРН: 1137746760381</p>

    <p>Юридический адрес: 119607, г. Москва, ул. Раменки, д. 25, корп. 3, кв. 668</p>

    <p>Сайт: <a href="https://new.realtycalendar.ru/" target="_blank">https://new.realtycalendar.ru/</a></p>

    <p>E-mail: support@realtycalendar.ru</p>

    <p>11. Заключительные положения</p>

    <p>11.1. Настоящая Политика вступает в силу с момента её утверждения Оператором и действует бессрочно до замены её новой Политикой.</p>

    <p>11.2. Изменения в настоящую Политику вносятся приказом Оператора. Изменения вступают в силу с момента, указанного в приказе.</p>

    <p>11.3. Актуальная редакция Политики размещается на Сайте Оператора по адресу: <a href="https://kamcvet-house.ru/" target="_blank">https://kamcvet-house.ru/</a>.</p>

    <p>&nbsp;</p>

  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyView',
}
</script>